<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M13.0517 4.61451C12.2938 4.04606 11.3063 4.04606 10.5484 4.61451L4.80483 8.9222C4.1771 9.393 3.80005 10.1856 3.80005 11.0343V19.2771C3.80005 20.679 4.81028 21.8155 6.05646 21.8155H9.33851C9.67838 21.8155 9.9539 21.5056 9.9539 21.1232V16.5078C9.9539 15.8706 10.4131 15.354 10.9795 15.354H12.6206C13.187 15.354 13.6462 15.8706 13.6462 16.5078V21.1232C13.6462 21.5056 13.9217 21.8155 14.2616 21.8155H17.5436C18.7898 21.8155 19.8 20.679 19.8 19.2771V11.0343C19.8 10.1856 19.423 9.39299 18.7953 8.9222L13.0517 4.61451Z"
			:fill="props.iconColor"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M13.9495 3.9288L21.3181 10.1904C21.6547 10.4765 21.6957 10.9814 21.4096 11.318C21.1235 11.6547 20.6187 11.6957 20.282 11.4096L12.8923 5.13008C12.8774 5.11738 12.8629 5.10414 12.8489 5.09037C12.4877 4.73451 12.1207 4.6 11.8 4.6C11.4794 4.6 11.1123 4.73451 10.7511 5.09037C10.7371 5.10414 10.7227 5.11738 10.7077 5.13008L3.31805 11.4096C2.98137 11.6957 2.4765 11.6547 2.1904 11.318C1.90429 10.9814 1.94529 10.4765 2.28198 10.1904L9.6505 3.9288C10.2604 3.33752 11.0076 3 11.8 3C12.5925 3 13.3397 3.33752 13.9495 3.9288Z"
			:fill="props.iconColor"
		/>
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 24,
		height: 24,
		iconColor: '#ffffff',
	}
);
</script>

<style lang="scss" scoped></style>
